<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(handleFormSubmit)">
      <div class="row">
        <div class="col-md-12">
          <div class="form-row d-flex justify-content-end">
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="is_bundle" v-model="is_bundle">
                <label class="form-check-label" for="is_bundle">
                  Bundle
                </label>
              </div>
            </div>
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="is_combo" v-model="is_combo">
                <label class="form-check-label" for="is_combo">
                  Combo
                </label>
              </div>
            </div>
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="show_code" v-model="show_code">
                <label class="form-check-label" for="show_code">
                  Show {code}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">

          <fieldset class="form-group p-3 border">

            <legend class="w-auto px-2"><i class="fa fa-info-circle" aria-hidden="true"></i> General Information</legend>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="id_sku">SKU <code v-if="show_code">{sku}</code></label>
                  <input type="text" class="form-control" id="id_sku" placeholder="SKU" v-model="internalProduct.sku" />
                </div>
                <div class="form-group col-md-5">
                  &nbsp;
                </div>
                <div class="form-group col-md-1">
                  <label for="id_condition">Condition</label>
                  <select class="form-control" id="id_condition" v-model="internalProduct.condition">
                    <option value="UNKNOWN">Unknown</option>
                    <option value="NEW">New</option>
                    <option value="USED">Used</option>
                  </select>
                </div>
                <div class="form-group col-md-1">
                  <label for="id_sku">Sorting</label>
                  <select class="form-control" v-model="internalProduct.sorting_order">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                </div>
                <div class="form-group col-md-1">
                  <label for="is_featured">Featured</label>
                  <select class="form-control" id="is_featured" v-model="is_featured">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="id_title">Title <code v-if="show_code">{title}</code></label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_title"
                    placeholder="Title"
                    v-model="internalProduct.title"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="id_brand">Brand <code v-if="show_code">{brand}</code></label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_brand"
                    placeholder="Brand"
                    v-model="internalProduct.brand"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="id_category">Category <code v-if="show_code">{category}</code></label>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <select
                      :class="errors.length === 0 ? '' : 'error'"
                      class="form-control"
                      v-model="internalProduct.internal_product_category_id"
                      @change="chooseCategory"
                    >
                      <option value>-- None --</option>
                      <option
                        v-for="category in categories"
                        :key="category.id"
                        :value="category.id"
                      >{{ category.name }}</option>
                    </select>
                    <div class="text-danger">
                      <small>{{ errors[0] }}</small>
                    </div>
                  </ValidationProvider>
                </div>
                <div class="form-group col-md-3">
                  <label for="id_series">Series <code v-if="show_code">{series}</code></label>
                  <template v-if="series.length === 0">
                    <span tabindex="0" data-toggle="tooltip" title="Choose a category first">
                      <select class="form-control" disabled>
                        <option value>-- None --</option>
                      </select>
                    </span>
                  </template>
                  <template v-else>
                    <select
                      class="form-control"
                      v-model="internalProduct.internal_product_series_id"
                    >
                      <option value>-- None --</option>
                      <option
                        v-for="serie in series"
                        :key="serie.id"
                        :value="serie.id"
                      >{{ serie.sku }}</option>
                    </select>
                  </template>
                </div>
                <div class="form-group col-md-3">
                  <label for="id_types">Type <code v-if="show_code">{type}</code></label>
                  <select class="form-control" v-model="internalProduct.internal_product_type_id">
                    <option value>-- None --</option>
                    <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
                  </select>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12"> <hr/> </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="id_short_description">Short Description</label>
                  <textarea
                    class="form-control"
                    id="id_short_description"
                    placeholder="Short Description"
                    v-model="internalProduct.short_description"
                  ></textarea>
                </div>
                <div class="form-group col-md-6">
                  <label for="id_description">Description</label>
                  <textarea
                    class="form-control"
                    id="id_description"
                    placeholder="Description"
                    v-model="internalProduct.description"
                  ></textarea>
                </div>
              </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2"><i class="fa fa-tag" aria-hidden="true"></i> Price</legend>
              <div class="form-row">
                <div class="form-group col-md-2">
                  <label for="id_retail_price">Retail</label>
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_retail_price"
                      placeholder="Retail Price"
                      v-model="internalProduct.retail_price"
                    />
                  </div>
                </div>
                <div class="form-group col-md-2">
                  <label for="id_retail_price">Wholesale</label>
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_wholesale_price"
                    />
                  </div>
                </div>
                <div class="form-group col-md-2">
                  &nbsp;
                </div>
                <div class="form-group col-md-2">
                  <label for="id_retail_price">Cost</label>
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_cost"
                    />
                  </div>
                </div>
                <div class="form-group col-md-2">
                  <label for="id_retail_price">Min</label>
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_min_price"
                    />
                  </div>
                </div>
                <div class="form-group col-md-2">
                  <label for="id_retail_price">Max</label>
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_max_price"
                    />
                  </div>
                </div>
              </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2"><i class="fa fa-hashtag" aria-hidden="true"></i> Identifiers</legend>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="id_asin">ASIN</label>
                  <input type="text" class="form-control" id="id_asin" placeholder="ASIN" v-model="internalProduct.asin" />
                </div>
                <div class="form-group col-md-3">
                  <label for="id_upc">UPC</label>
                  <input type="text" class="form-control" id="id_upc" placeholder="UPC" v-model="internalProduct.upc" />
                </div>
                <div class="form-group col-md-3">
                  <label for="id_brand">MPN</label>
                  <input type="text" class="form-control" id="id_mpn" placeholder="MPN" v-model="internalProduct.mpn" />
                </div>
              </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2"><i class="fa fa-th-large" aria-hidden="true"></i> Size</legend>
              <div class="form-row">
                <div id="common-fields" class="form-inline col-md-12"></div>
              </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2"><i class="fa fa-list-ul" aria-hidden="true"></i> Features</legend>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">#1</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point1"
                      placeholder="Bullet Point 1"
                      v-model="internalProduct.bullet_point1"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">#2</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point2"
                      placeholder="Bullet Point 2"
                      v-model="internalProduct.bullet_point2"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">#3</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point3"
                      placeholder="Bullet Point 3"
                      v-model="internalProduct.bullet_point3"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">#4</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point4"
                      placeholder="Bullet Point 4"
                      v-model="internalProduct.bullet_point4"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">#5</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point5"
                      placeholder="Bullet Point 5"
                      v-model="internalProduct.bullet_point5"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-11">
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">#6</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point6"
                      placeholder="Bullet Point 6"
                      v-model="internalProduct.bullet_point6"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-1">
                <input type="button" class="btn btn-secondary btn-sm btn-block" value="Generate" />
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-11">
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">#7</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point7"
                      placeholder="Bullet Point 7"
                      v-model="internalProduct.bullet_point7"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-1">
                <input type="button" class="btn btn-secondary btn-sm btn-block" value="Generate" />
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2"><i class="fa fa-sitemap" aria-hidden="true"></i> Domain Specific</legend>
            <div class="form-row">
              <div class="tabset">
                <!-- Tab 1 -->
                <input type="radio" name="tabset" id="domain_1" aria-controls="maxtop" checked>
                <label for="domain_1">Maxtop</label>
                <!-- Tab 2 -->
                <input type="radio" name="tabset" id="domain_2" aria-controls="bommeow">
                <label for="domain_2">Bommeow</label>
                <!-- Tab 3 -->
                <input type="radio" name="tabset" id="domain_3" aria-controls="maxtopcomms">
                <label for="domain_3">MaxtopComms</label>

                <div class="tab-panels">
                  <section id="maxtop" class="tab-panel">
                    
                    <div class="form-row">
                      <div class="form-group col-md-1">
                        <label for="id_maxtop_status">Status</label>
                        <select class="form-control" id="id_maxtop_status">
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>
                      <div class="form-group col-md-11">
                        <label for="id_maxtop_title">Title</label>
                        <input
                          type="text"
                          class="form-control"
                          id="mt_title"
                          placeholder="Title"
                          value="{sku}"
                        />
                      </div>
                    </div>
                  </section>
                  <section id="bommeow" class="tab-panel">
                    <div class="form-row">
                      <div class="form-group col-md-1">
                        <label for="id_bommeow_status">Status</label>
                        <select class="form-control" id="id_bommeow_status">
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>
                      <div class="form-group col-md-11">
                        <label for="id_bommeow_title">Title</label>
                        <input
                          type="text"
                          class="form-control"
                          id="bm_title"
                          placeholder="Title"
                          value="{sku}"
                        />
                      </div>
                    </div>
                  </section>
                  <section id="maxtopcomms" class="tab-panel">
                    <div class="form-row">
                      <div class="form-group col-md-1">
                        <label for="id_maxtopcomms_status">Status</label>
                        <select class="form-control" id="id_maxtopcomms_status">
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>
                      <div class="form-group col-md-11">
                        <label for="id_maxtopcomms_title">Title</label>
                        <input
                          type="text"
                          class="form-control"
                          id="mc_title"
                          placeholder="Title"
                          value="{sku}"
                        />
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2"><i class="fa fa-search" aria-hidden="true"></i> SEO</legend>
            <div class="form-row">
              <div class="tabset">
                <!-- Tab 1 -->
                <input type="radio" name="seo_tabset" id="seo_1" aria-controls="maxtop_seo" checked>
                <label for="seo_1">Maxtop</label>
                <!-- Tab 2 -->
                <input type="radio" name="seo_tabset" id="seo_2" aria-controls="bommeow_seo">
                <label for="seo_2">Bommeow</label>

                <div class="tab-panels">
                  <section id="maxtop_seo" class="tab-panel">
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="id_maxtop_seo_title">Title</label>
                        <input type="text" class="form-control" id="id_maxtop_seo_title" placeholder="SEO Title" />
                      </div>
                      <div class="form-group col-md-12">
                        <label for="id_maxtop_seo_keywords">Keywords</label>
                        <input type="text" class="form-control" id="id_maxtop_seo_keywords" placeholder="SEO Keywords" />
                      </div>
                      <div class="form-group col-md-12">
                        <label for="id_maxtop_seo_description">Description</label>
                        <input type="text" class="form-control" id="id_maxtop_seo_description" placeholder="SEO Description" />
                      </div>
                      <div class="form-group col-md-12">
                        <label for="id_maxtop_seo_handle">Handle</label>
                        <input type="text" class="form-control" id="id_maxtop_seo_handle" placeholder="Handle" />
                      </div>
                    </div>
                  </section>
                  <section id="bommeow_seo" class="tab-panel">
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="id_bommeow_seo_title">Title</label>
                        <input type="text" class="form-control" id="id_bommeow_seo_title" placeholder="SEO Title" />
                      </div>
                      <div class="form-group col-md-12">
                        <label for="id_bommeow_seo_keywords">Keywords</label>
                        <input type="text" class="form-control" id="id_bommeow_seo_keywords" placeholder="SEO Keywords" />
                      </div>
                      <div class="form-group col-md-12">
                        <label for="id_bommeow_seo_description">Description</label>
                        <input type="text" class="form-control" id="id_bommeow_seo_description" placeholder="SEO Description" />
                      </div>
                      <div class="form-group col-md-12">
                        <label for="id_bommeow_seo_handle">Handle</label>
                        <input type="text" class="form-control" id="id_bommeow_seo_handle" placeholder="Handle" />
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border" v-if="is_bundle">
            <legend class="w-auto px-2"><i class="fa fa-cubes" aria-hidden="true"></i> Bundle</legend>
            <div class="form-row">
              <div class="form-group col-md-1">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="p1ps" v-model="is_1ps">
                  <label class="form-check-label" for="p1ps">1PS</label>
                </div>
              </div>
              <div class="form-group col-md-1">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="p2ps" v-model="is_2ps">
                  <label class="form-check-label" for="p2ps">2PS</label>
                </div>
              </div>
              <div class="form-group col-md-1">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="p4ps" v-model="is_4ps">
                  <label class="form-check-label" for="p4ps">4PS</label>
                </div>
              </div>
              <div class="form-group col-md-1">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="p10ps" v-model="is_10ps">
                  <label class="form-check-label" for="p10ps">10PS</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6" v-if="is_2ps">
                <div class="card">
                  <div class="card-header">
                    <strong><i class="fa fa-cubes" aria-hidden="true"></i> 2PS</strong>
                  </div>
                  <div class="card-body">
                    <div class="form-row">
                      <div class="form-group col-md-9">
                        <label for="id_sku">SKU</label>
                        <input type="text" class="form-control" id="id_2ps_sku" placeholder="SKU" value="2PS-{sku}"/>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="id_retail_price">Price</label>
                        <div class="input-group mb-2 mr-sm-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">$</div>
                          </div>
                          <input type="text" class="form-control" id="id_2ps_price" placeholder="Price" />
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="id_asin">ASIN</label>
                        <input type="text" class="form-control" id="id_2ps_asin" placeholder="ASIN" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="id_upc">UPC</label>
                        <input type="text" class="form-control" id="id_2ps_upc" placeholder="UPC" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="id_brand">MPN</label>
                        <input type="text" class="form-control" id="id_2ps_mpn" placeholder="MPN" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6" v-if="is_4ps">
                <div class="card">
                  <div class="card-header">
                    <strong><i class="fa fa-cubes" aria-hidden="true"></i> 4PS</strong>
                  </div>
                  <div class="card-body">
                    <div class="form-row">
                      <div class="form-group col-md-9">
                        <label for="id_sku">SKU</label>
                        <input type="text" class="form-control" id="id_4ps_sku" placeholder="SKU" value="4PS-{sku}"/>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="id_retail_price">Price</label>
                        <div class="input-group mb-2 mr-sm-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">$</div>
                          </div>
                          <input type="text" class="form-control" id="id_4ps_price" placeholder="Price" />
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="id_asin">ASIN</label>
                        <input type="text" class="form-control" id="id_4ps_asin" placeholder="ASIN" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="id_upc">UPC</label>
                        <input type="text" class="form-control" id="id_4ps_upc" placeholder="UPC" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="id_brand">MPN</label>
                        <input type="text" class="form-control" id="id_4ps_mpn" placeholder="MPN" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6" v-if="is_10ps">
                <div class="card">
                  <div class="card-header">
                    <strong><i class="fa fa-cubes" aria-hidden="true"></i> 10PS</strong>
                  </div>
                  <div class="card-body">
                    <div class="form-row">
                      <div class="form-group col-md-9">
                        <label for="id_sku">SKU</label>
                        <input type="text" class="form-control" id="id_10ps_sku" placeholder="SKU" value="10PS-{sku}"/>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="id_retail_price">Price</label>
                        <div class="input-group mb-2 mr-sm-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">$</div>
                          </div>
                          <input type="text" class="form-control" id="id_10ps_price" placeholder="Price" />
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="id_asin">ASIN</label>
                        <input type="text" class="form-control" id="id_10ps_asin" placeholder="ASIN" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="id_upc">UPC</label>
                        <input type="text" class="form-control" id="id_10ps_upc" placeholder="UPC" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="id_brand">MPN</label>
                        <input type="text" class="form-control" id="id_10ps_mpn" placeholder="MPN" />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border" v-if="is_combo">
            <legend class="w-auto px-2"><i class="fa fa-plus-square" aria-hidden="true"></i> Combo</legend>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="combo_sku_1">SKU</label>
              </div>
              <div class="form-group col-md-1">
                <label for="combo_qty_1">Qty</label>
              </div>
              <div class="form-group col-md-1 text-center small">
                <a href="javascript:"><i class="fa fa-plus" aria-hidden="true"></i></a>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <input type="text" class="form-control" id="combo_sku_1" placeholder="SKU" />
              </div>
              <div class="form-group col-md-1">
                <select class="form-control">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
              <div class="form-group col-md-1 text-center small">
                <a href="javascript:"><i class="fa fa-minus" aria-hidden="true"></i></a>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <input type="text" class="form-control" id="combo_sku_1" placeholder="SKU" />
              </div>
              <div class="form-group col-md-1 text-center small">
                <select class="form-control">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
              <div class="form-group col-md-1 text-center small">
                <a href="javascript:"><i class="fa fa-minus" aria-hidden="true"></i></a>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <input type="text" class="form-control" id="combo_sku_1" placeholder="SKU" />
              </div>
              <div class="form-group col-md-1 text-center small">
                <select class="form-control">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
              <div class="form-group col-md-1 text-center">
                <a href="javascript:"><i class="fa fa-minus" aria-hidden="true"></i></a>
              </div>
            </div>
          </fieldset>

          <div class="form-row">
            <CustomFields
              :readonly="!['', null].includes(internalProduct.internal_product_series_id)"
              :category="internalProduct.internal_product_category_id === '' ? null : internalProduct.internal_product_category_id"
              :internal-product="internalProduct.id"
              :series="internalProduct.internal_product_series_id === '' ? null : internalProduct.internal_product_series_id"
              @select="handleCustomFieldsSelect"
            />
          </div>
        </div>
        <!-- close col-md-12 -->
      </div>
      <!-- close row -->
      <div class="row">
        <div class="col-md-12 text-right">
          <button class="btn btn-primary btn-icon-splitfloat-right">{{ type }}</button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import CustomFields from '@/components/Common/CustomFields.vue';
import InternalProductApiRequest from '@/components/ApiRequester/InternalProduct.js';
import CategoryApiRequest from '@/components/ApiRequester/Category.js';
import CategorySeriesApiRequest from '@/components/ApiRequester/CategoryTypesSeries.js';
import TypeApiRequest from '@/components/ApiRequester/CategoryTypes.js';
import CommonFieldApiRequest from '@/components/ApiRequester/CommonField.js';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'InternalProductForm',
  props: {
    type: {
      required: true,
      type: String,
      validator: (val) => ['Create', 'Update'].includes(val),
    },
    item: {
      required: false,
      type: Object,
      default: () => null,
    },
  },
  components: {
    CustomFields,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    show_code: false,
    is_bundle: false,
    is_combo: false,
    is_featured: 0,
    is_1ps: true,
    is_2ps: false,
    is_4ps: false,
    is_10ps: false,
    categories: [],
    series: [],
    types: [],
    commonFields: [],
    internalProduct: {
      id: null,
      sku: '',
      sorting_order: 3,
      retail_price: '',
      brand: '',
      condition: '',
      title: '',
      internal_product_category_id: '',
      internal_product_series_id: '',
      internal_product_type_id: '',
      short_description: '',
      description: '',
      asin: '',
      upc: '',
      mpn: '',
      bullet_point1: '',
      bullet_point2: '',
      bullet_point3: '',
      bullet_point4: '',
      bullet_point5: '',
    },
    customFields: {},
  }),
  created() {
    if (this.$props.item !== null) {
      this.internalProduct = Object.assign(this.internalProduct, {
        id: this.$props.item.id,
        sku: this.$props.item.sku,
        sorting_order: this.$props.item.sorting_order,
        retail_price: this.$props.item.retail_price,
        brand: this.$props.item.brand,
        condition: this.$props.item.condition,
        title: this.$props.item.title,
        internal_product_category_id: this.$props.item.internal_product_category_id,
        internal_product_series_id: this.$props.item.internal_product_series_id,
        internal_product_type_id: this.$props.item.internal_product_type_id,
        short_description: this.$props.item.short_description,
        description: this.$props.item.description,
        asin: this.$props.item.asin,
        upc: this.$props.item.upc,
        mpn: this.$props.item.mpn,
        bullet_point1: this.$props.item.bullet_point1,
        bullet_point2: this.$props.item.bullet_point2,
        bullet_point3: this.$props.item.bullet_point3,
        bullet_point4: this.$props.item.bullet_point4,
        bullet_point5: this.$props.item.bullet_point5,
      });
    }

    extend('required', {
      validate (value) {
        return {
          required: true,
          valid: ['', null, undefined].indexOf(value) === -1
        }
      },
      computesRequired: true,
      message: 'This field is required',
    });
  },
  mounted() {
    document.getElementById('loader').classList.add('active');
    if (this.internalProduct.internal_product_category_id !== '') {
      Promise.all([
        this.fetchCategories(),
        this.fetchSeries(),
        this.fetchTypes(),
        this.fetchCommonFields()
      ]).then(([categoryResources, seriesResources, typeResources, commonFieldResources]) => {
        this.categories = categoryResources;
        this.series = seriesResources;
        this.types = typeResources;
        this.commonFields = commonFieldResources;

        this.renderCommonFields();

        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    } else {
      Promise.all([
        this.fetchCategories(),
        this.fetchTypes(),
        this.fetchCommonFields()
      ]).then(([categoryResources, typeResources, commonFieldResources]) => {
        this.categories = categoryResources;
        this.types = typeResources;
        this.commonFields = commonFieldResources;

        this.renderCommonFields();

        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    }
  },
  methods: {
    fetchCommonFields() {
      let payload = {};

      if (this.$props.item !== null) {
        payload = Object.assign({}, {
          internal_product_id: this.internalProduct.id
        })
      }

      const ApiRequester = new CommonFieldApiRequest();
      return ApiRequester.all(payload).then((response) => response.data);
    },
    renderCommonFields() {
      const parent = document.querySelector('#common-fields');
      this.commonFields.forEach((commonField) => {
        const formGroup = document.createElement('div');
        formGroup.classList.add('form-group');
        formGroup.classList.add('mb-4');
        formGroup.classList.add('w-100');

        const label = document.createElement('label');
        label.classList.add('pr-4')
        label.innerHTML = commonField.label;

        formGroup.append(label);

        if (commonField.type === 'multiple-input') {
          commonField.properties.forEach((property) => {
            const el = document.createElement(property.type)
            el.value = property.value

            el.addEventListener('change', (event) => {
              property.value = event.target.value;
            });

            switch (property.type) {
              case 'input': {
                el.type = 'number'

                el.classList.add('form-control');
                el.classList.add('form-control-sm');

                const inputGroup = document.createElement('div');
                inputGroup.classList.add('input-group');
                inputGroup.classList.add('input-group-sm');
                inputGroup.classList.add('px-0');
                inputGroup.style.cssText = 'width: 100px !important;';
                inputGroup.append(el);

                const inputGroupPrepend = document.createElement('div');
                inputGroupPrepend.classList.add('input-group-prepend')

                const inputGroupText = document.createElement('span');
                inputGroupText.classList.add('input-group-text')
                inputGroupText.innerHTML = property.label;

                inputGroupPrepend.append(inputGroupText);
                inputGroup.append(inputGroupPrepend);
                formGroup.append(inputGroup)

                break;
              }
              case 'label': {
                el.innerHTML = property.value;
                el.classList.add('mx-2')
                formGroup.append(el);
                break;
              }
            }
          })
        }

        parent.append(formGroup);
      });
    },
    handleCustomFieldsSelect(customFields) {
      this.customFields = Object.assign({}, customFields);
    },
    handleFormSubmit() {
      const ApiRequester = new InternalProductApiRequest();

      this.internalProduct = Object.assign(this.internalProduct, {
        common_fields: this.commonFields,
        custom_fields: this.customFields,
      });

      let payload = { data: this.internalProduct };

      switch (this.$props.type) {
        case 'Create':
          payload = Object.assign(payload, { method: 'POST' });
          break;
        case 'Update':
          payload = Object.assign(payload, { method: 'PUT' });
          break;
      }

      document.getElementById('loader').classList.add('active');

      ApiRequester.store(payload).then(() => {
        document.getElementById('loader').classList.remove('active');
        this.$emit('submit');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      })
    },
    fetchCategories() {
      const ApiRequester = new CategoryApiRequest();
      return ApiRequester.all().then((response) => response.data.categories);
    },
    fetchSeries() {
      const ApiRequester = new CategorySeriesApiRequest();
      return ApiRequester.all({
        category_id: this.internalProduct.internal_product_category_id
      }).then((response) => response.data.series);
    },
    fetchTypes() {
      const ApiRequester = new TypeApiRequest();
      return ApiRequester.all().then((response) => response.data.types);
    },
    chooseCategory() {
      document.getElementById('loader').classList.add('active');
      this.fetchSeries().then((seriesResources) => {
        this.series = seriesResources;
        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.error {
  border-color: red;
}
</style>
